var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{staticClass:"text-left ml-6"},[_c('v-btn',{staticStyle:{"text-align":"left"},attrs:{"color":"black","dark":""},on:{"click":function($event){return _vm.$router.go(-1);}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-step-backward")]),_vm._v("Back")],1)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }